import styled from 'styled-components'

export const MainLayout = styled.div`
    padding: 4.5rem;
    @media screen and (max-width: 500px) {
        padding: 2.5rem;
    }
`

export const InnerLayout = styled.div`
    padding: 4.5rem 0;
    /* padding: 0; */
`
